import React, { FC, MouseEvent } from 'react';
import { StyledModalSection } from './GenericDialogueModal.styles';
import { Heading, Text, Types, Button } from '@marriott/mi-ui-library';
import { ExitModalProps } from './GenericDialogueModal.types';
// import { formData } from '../../organisms/Submit/formData_mock';
import { useCreateSurveyStore } from '../../store/createSurveyStore';
import DOMPurify from 'isomorphic-dompurify';

export const GenericDialogueModal: FC<ExitModalProps> = ({
  isVisible,
  modalType,
  errorHeading,
  errordesc,
  onClose,
  onSubmit,
}) => {
  const { formData, setFormData } = useCreateSurveyStore(); // Access formData from Zustand store
  const handleClose = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setFormData({ ...formData, isSubmitDataFlow: false, isReviewPageFlow: false });
    onClose();
  };

  const handleButtonClick = () => {
    setFormData({ ...formData, isSubmitDataFlow: false, isReviewPageFlow: false });
    onSubmit();
  };

  if (!isVisible) {
    return null;
  }

  let modalTitle = '';
  let modalText = '';
  let buttonCopy = '';
  let modalClass = '';

  switch (modalType) {
    case 'exitModal':
      modalTitle = 'Before You Go...';
      // modalText = `We noticed that you have opted to not complete the travel survey. Please contact our ${formData.property_config.brand_name} team by email ${formData.property_config?.hotel_contact_email} or phone ${formData.property_config.phone_number_txt} if we can be of assistance in your planning before you arrive. Our team can assist with reservations for dining, experiences, and honor special requests.`;
      modalText = `We noticed that you have opted to not complete the travel survey. Please contact our ${
        formData.property_config.brand_name
      } team by email ${formData.property_config?.hotel_contact_email} or phone ${
        formData.property_config.phone_number
          ? `+${formData.property_config.phone_number.country_code} ${formData.property_config.phone_number.area_code} ${formData.property_config.phone_number.phone_number}`
          : ''
      } if we can be of assistance in your planning before you arrive. Our team can assist with reservations for dining, experiences, and honor special requests.`;

      buttonCopy = 'Exit';
      modalClass = '';
      break;
    case 'submitModal':
      modalTitle = 'Ready to Submit?';
      modalText = `Once you submit this form, our team will begin creating a curated itinerary based off of your preferences and requests - and email it to you at ${formData?.reservation?.cusotmerEmail}. Unfortunately, once you submit this form, you can not edit or resubmit.`;
      buttonCopy = 'Submit';
      modalClass = 'submit-modal';
      break;
    case 'problemModal':
      modalTitle = 'Problem Encountered';
      modalText = `There was an error submitting the response. Please contact our hotel team directly at ${formData?.property_config?.hotel_contact_email} or call our property directly for further assistance.`;
      buttonCopy = 'Exit';
      modalClass = 'problem-modal';
      break;
    case 'alreadySubmittedModal':
      modalTitle = `${errorHeading}`;
      modalText = `${errordesc}`;
      buttonCopy = 'Exit';
      modalClass = 'submited-modal';
      break;
  }

  const sanitizedNode1 = DOMPurify.sanitize(modalText, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString1 = sanitizedNode1.innerHTML;

  return (
    <StyledModalSection>
      <div className="prearrival-modal-overlay">
        <div className={`exit-modal ${modalClass}`}>
          <div className="container">
            <div className="row">
              <div className="col-12 pr-0 px-0 modal-wrapper">
                <div className="close-button-container">
                  <button className="close-button" onClick={handleClose}>
                    &#10006;
                  </button>
                </div>
                <Heading
                  variation={Types.headingType.title}
                  fontSize={Types.size.medium}
                  element={Types.tags.h1}
                  titleText={modalTitle}
                  disableCustomClickTrack={true}
                  customClass="mb-4 modal-heading"
                />
                <div className="inside-div">
                  <Text
                    element={Types.tags.paragraph}
                    fontSize={Types.size.medium}
                    dangerouslySetInnerHTML={{ __html: fragmentString1 }}
                    customClass="subtitle"
                  />
                  <div className="col-12 p-0 d-flex justify-content-end button-wrapper">
                    <Button
                      className="m-button-m m-button-primary custom-btn mx-0"
                      type={Types.ButtonTypeVariation.Button}
                      buttonCopy={buttonCopy}
                      id="submitRequest"
                      callback={handleButtonClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledModalSection>
  );
};

export default GenericDialogueModal;
